import EventEmitter from 'events';
import store from '../store';
import ControllerServerComs from 'system/ControllerServerComs';
import { endpoints, branding } from 'config';
import { startHeartbeat } from 'system/Heartbeat';
import Analytics from 'system/Analytics';

var Globals= (function(){
    var instance;

    class globals {

    constructor() {
        this.env = false
        this.format = 'web'
        this.contentpath = ''
        this.cmspath = ''
        this.version= "7.7.1"
        this.build="7.7.42"
        this.events= new EventEmitter()
        this.coreSynched = false
        this.initCanvas()
        this.isTouch= this.is_touch_device()
        this.basepath=''
        this.width=window.innerWidth
        this.height=window.innerHeight
        this.aspect_ratio = window.innerWidth/window.innerHeight
        this.ios=this.isIOS()
        this.ipad=this.isIpadOS()
        this.iosOverlay=false
        this.electron=false
        this.bookmarks=[]
        this.downloaded=[]
        this.nid=null
        this.isFullscreen = false
        this.narrativeHelp = branding.helpNarrativeId;
        this.narrativeHelpLargeTouch = branding.helpLargeTouchNarrativeId;
        this.narrativeHelpController = branding.helpControllerNarrativeId;
        this.prefNavBox = true;
        this.appPath = "";
        this.useLocal = false;
        this.device_width = null;
        this.device_height = null;
        this.offlineMode=false;
        this.noInternet=false;
        this.onLanding=true;
        this.currentPageIndex=0;

        // Endpoints from centralized config (auto-detects staging/live from build)
        this.adminAPI = endpoints.api;
        this.webURL = endpoints.web;
        this.adminOriginAPI = endpoints.apiOrigin;
        this.cmsEditLink = endpoints.cms;
        this.socketURL = endpoints.socket;


      
        // 

        var userAgent = navigator.userAgent;
        if (userAgent && userAgent.toLowerCase().indexOf('electron/') > -1) {
          this.electron=true
        }
        

       
        
        this.serverIP = '';
        this.controllerPing = false;
        this.usbRequested = false;
        
        
    }

    init(){
        this.basepath=process.env.REACT_APP_BASE?process.env.REACT_APP_BASE:''
        this.mode = process.env.REACT_APP_BUILD_MODE?process.env.REACT_APP_BUILD_MODE: 'web';
        this.analyticsId=process.env.REACT_APP_GA?process.env.REACT_APP_GA:''
        this.useHashRouter = this.mode.indexOf('local') > -1
        this.usecms = this.mode.indexOf('cms') > -1
        
        this.controllerApp = process.env.REACT_APP_CTRL==="APPCONTROLLER"
        this.serverApp = process.env.REACT_APP_SERVER==="APPSERVER"
        this.presentationMode = process.env.REACT_APP_PRESENTATION==="PRESENTATION"
        this.dualOutput = process.env.REACT_APP_DUAL_OUTPUT==="DUAL"

        let p = process.env.REACT_APP_CONTENT
        this.loadedContentpath = (p ? p : '/' )
        this.contentpath = (p ? p : '/' )
        this.cmspath = this.adminAPI

        this.localCmsPath='./api/'
        this.localContentPath='./media/'
        

        if(this.mode!=='static-web')
          this.cmspath = this.cmspath +'/api/' ;//p ? p : '/'
        

        if(this.ios) this.mode='local'

        if(this.ios || this.serverApp){
          this.cmspath='./api/'
          this.contentpath='./media/'
          this.useHashRouter=true
          this.usecms=false

        }

        if (this.useLocal) {
          this.usecms = false
        }
        
        // if(this.ios || this.electron){
        //   this.cmspath='./api/'
        //   this.contentpath='./media/'
        //   this.useHashRouter=true
        //   this.usecms=false
        // }
        console.log("build number", this.build)
        console.log("mode : "+this.mode)
        console.log("router : "+(this.useHashRouter?'hash':"browser"))
        console.log("cms : " + (this.usecms?'using cms':"using static"))
        console.log("cms path : "+this.cmspath)
        console.log("content path : " + this.contentpath)
        console.log("api path : " + this.adminAPI)
        console.log("offlineMode : " + this.offlineMode)
        console.log("noInternet : " + this.noInternet)

        let format = document.body.getAttribute('format')
        this.format = format ? format : 'web' 
        
        let env = document.body.getAttribute('env')
        this.env = env ? env : 'development' 
        
        this.version = process.env.REACT_APP_VERSION

        console.log('verison : '+ this.version +' '+this.env)
        console.log('format : '+this.format)

        if(this.format ==='web'){
          window.addEventListener('resize',()=>{
            let ele = document.getElementById('main')
             this.aspect_ratio = ele.clientWidth/ele.clientHeight
             
            //  console.log('aspect: '+this.aspect_ratio)
          },{passive:true})
        }

        if(this.ios)
          document.body.classList.add('ios')
        if(this.ipad)
          document.body.classList.add('ipad')
       
        this.updatebookmarks()
        if(this.electron){
          this.listenElectron()
          this.isFullscreen=true //electron apps open in fullscreen

        }        
        
        //CREATING IN WEBGL ISSUES
        if(this.ios){
          window.createImageBitmap = undefined
        }
        // window.createImageBitmap=undefined
        
        // Set up periodic internet connectivity checks (every 30 seconds).
        // Runs on ALL platforms now, including Electron/iOS kiosks - those are
        // exactly the devices that can latch offline on a slow cold-start, and
        // without a periodic re-check they never re-detect the now-fast network.
        setInterval(() => {
          this.recheckInternetStatus();
        }, 30000);
        
        if(document.body.getAttribute("controllerApp")==="true" || (new URLSearchParams(window.location.search)).get("controllerApp")==="true"){
          this.controllerApp = true
        }
        if(document.body.getAttribute("serverApp")==="true" || (new URLSearchParams(window.location.search)).get("serverApp")==="true"){
          this.serverApp = true
        }
        if(document.body.getAttribute("presentationMode")==="true" || (new URLSearchParams(window.location.search)).get("presentationMode")==="true"){
          this.presentationMode = true
        }
        if((new URLSearchParams(window.location.search)).get("prefNavBox")==="false"){
          this.prefNavBox = false
        }
        if((new URLSearchParams(window.location.search)).get("iosOverlay")==="true"){
          this.iosOverlay=true
          document.body.style.backgroundColor='transparent'
          document.body.parentElement.style.backgroundColor='transparent'
          
        }
        // Check for offlineMode from URL parameter (set by the iOS app based on
        // file availability, and by the desktop when it boots local offline).
        if((new URLSearchParams(window.location.search)).get("offlineMode")==="true"){
          this.offlineMode=true
          // Route content/API paths to local files immediately, so the offline
          // boot doesn't fetch (and hang on) the unreachable remote before the
          // connectivity ping resolves. Mirrors markOffline.
          this.useLocal=true
          this.useCMS=false
          localStorage.setItem('offlineMode', 'true')
          console.log('offlineMode set from URL parameter:', this.offlineMode)
        }
        if (!(Globals.instance().electron || (Globals.instance().ios))) {
          this.offlineMode = false
          localStorage.setItem('offlineMode', 'false')
           console.log('set offline mode false')
        }

        let downloadCookie = localStorage.getItem('expo.downloaded')
        if (downloadCookie) {
          this.downloaded = JSON.parse(downloadCookie)
        }
        
        if(this.controllerApp) document.body.classList.add('controllerApp')
        if(this.serverApp) document.body.classList.add('serverApp')
        if(this.presentationMode) document.body.classList.add('presentationMode')
        if(!this.electron) document.body.classList.add('electronApp')
        // if(this.aspect_ratio) document.body.classList.add(this.aspect_ratio)

        console.log("CONTROLLER MODE : "+ this.controllerApp)
        console.log("SERVER MODE : "+ this.serverApp)
        console.log("PRESENTATION MODE : "+ this.presentationMode)

        startHeartbeat();
        Analytics.initAnalytics(this.analyticsId, { nativeApp: this.electron || this.ios || this.ipad });

    }

    listenElectron(){
      console.log("listenElectron");
      window.api.receive("fromApp", (data) => {
        console.log("fromApp Received", data);
        let objFromApp =data[0]
        if(objFromApp.action === 'location'){
              window.location= 'file://'+objFromApp.message
              // console.log('window.location', 'file://'+objFromApp.message)
        }

     

        if(objFromApp.action === 'window-event'){
          console.log(`Received ${JSON.stringify(data)} from main process`);
          window.dispatchEvent(new CustomEvent('window-event',{detail:objFromApp.detail}))

            let detail = data.detail
            if(detail && detail.event==='set-fullscreen-on'){
              Globals.instance().isFullscreen=true
            }
            else if (detail && detail.event==='set-fullscreen-off'){
              Globals.instance().isFullscreen=false
            }
        }
        if(objFromApp.action === 'server-event'){
          let detail = data.detail
           if(detail && detail.event==='turn-on-serverApp'){
             Globals.instance().serverApp=true
          }

         
        }

 

    });
    
    }
    initCanvas(){
      //canvas
      this.eleCanvas = document.createElement('canvas');
      this.eleCanvas.style['z-index']=-10
      this.eleCanvas.style.visibility='hidden'
      document.body.appendChild(this.eleCanvas)
    }

    is_touch_device() {  
      try {  
        document.createEvent("TouchEvent");  
        return true;  
      } catch (e) {  
        return false;  
      }  
    }

    getCanvasFormat(arrFormats,pageFormat){
      let f =null
      if(pageFormat){
        f=arrFormats.find( f=>{return f.aspect_ratio===pageFormat.aspect_ratio})
      }
      // console.log(pageFormat.aspect_ratio,f)
     
      if(!f){
        f=arrFormats.find( f=>{return f.aspect_ratio==='16:9'})
      }
      if(!f && arrFormats.length){
        f=arrFormats[0]
      }
      
      
      return f
    }

    getFormat(arrFormats,fallback){
        let closest = Infinity
        let f = null
        //default 
        if(!arrFormats || arrFormats.length===0){
          if(fallback)return fallback
          return {
            "aspect_ratio":"16:9",
            "canvas_width":"1920px",
            "canvas_height":"1080px",
            "crop":false
          }
        }

        arrFormats.forEach((format)=>{
          let aspect_ratio = format['aspect-ratio']
          
          if(format['aspect_ratio']){ aspect_ratio=format['aspect_ratio']}
          
          // console.log("format['aspect_ratio']", format['aspect_ratio'], this.width, Math.abs(this.stringToAspect(aspect_ratio) - this.width))
          
          // console.log("TABLET CHECK", width >= parseInt(format['canvas_width'].replace('px', '')))
          let d = Math.abs(this.stringToAspect(aspect_ratio) - this.aspect_ratio)

          function validFormat() {
            let r = true;
            // console.log(format['max_canvas_width'], window.innerWidth)
            if (format['max_canvas_width']){
              if (window.innerWidth <= format['max_canvas_width']) {
                r = true;
              } else {
                r = false;
              }

            } 
            return r
          }

          // console.log('tablet check', validFormat(), format['aspect_ratio'], d)

          if(d<closest && validFormat()){
              closest = d
              f=format
          }

        })
        // console.log('getFormat',f) 
        return f
    }

    stringToAspect(str){
      let aspect_ratio;
      aspect_ratio=Number(Number(str))/1
      return aspect_ratio
    }

    getRoute(route){
      // console.log('getRoute', route)
      return this.basepath+route
    }
    
    isIOS() {
      // Identify OUR native iPad apps, not "any WKWebView". Both register a
      // named handler before the page loads: "notification" (expostudio-ipad)
      // and "controllerHandler" (expostudio-ipad-controller).
      //
      // A bare window.webkit.messageHandlers test is NOT specific to them.
      // Every WKWebView-backed browser on iOS defines that object -- Chrome
      // (CriOS) registers crwebinvoke/FrameBecameAvailable on every page, and
      // Firefox and the in-app browsers of Slack/LinkedIn/Instagram do the
      // same. Those all matched, so the app set mode='local', usecms=false and
      // cmspath='./api/', then asked S3 for ./api/core/narratives.json, which
      // does not exist -- surfacing as "Could not load narratives. Your access
      // token may be invalid." Share links died in mobile Chrome for that
      // reason while mobile Safari, which defines no handlers, was fine.
      const handlers = window.webkit && window.webkit.messageHandlers
      return !!(handlers && (handlers.notification || handlers.controllerHandler))
    }
    
    iosVersion(){
      let d, v;
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      d = {
        status: true,
        version: parseInt(v[1], 10) , 
        info: parseInt(v[1], 10)+'.'+parseInt(v[2], 10)+'.'+parseInt(v[3] || 0, 10)
      };
    }else{
      d = {status:false, version: false, info:''}
    }
    return d;
    }
    
    isIpadOS(){
      if(navigator.userAgent.toLowerCase().indexOf('ipad')>-1)return true
      let bIpad= navigator.maxTouchPoints &&
      navigator.maxTouchPoints >= 2 &&
      /MacIntel/.test(navigator.platform);
      
      return bIpad
    }

    getThemeStyle(arrProperties,theme){
      let s={}
      if(theme && theme.lookup){
        
        arrProperties.forEach(p=>{
          let obj = {}
          for( let prop in theme.lookup[p]){
            let pkey = prop
            if(prop.indexOf("-")>0){
                let arr = pkey.split('-')
                pkey=arr[0]+arr[1].charAt(0).toUpperCase() + arr[1].slice(1);
            }
            obj[pkey]=theme.lookup[p][prop]
          }
          s= Object.assign(s, obj)
        })
      }
    return s
    }
    
    trackEvent(action,args){
      Analytics.trackEvent(action,args)
    }
    trackPage(page){
      Analytics.trackPage(page)
    }
    trackError(desc,fatal){
      Analytics.trackError(desc,fatal)
    }

    showAlert(title,message,cancel,continueBtn){
      console.log('dispatch')
      window.dispatchEvent(new CustomEvent('alert',{detail:{title:title,message:message,cancel:cancel,continueBtn:continueBtn}}))
    }
    showToast(message){
      // Non-blocking, self-dismissing notice (rendered in Main.js). Unlike
      // showAlert this never blocks the UI - safe for an unattended kiosk.
      window.dispatchEvent(new CustomEvent('show-toast',{detail:{message:message}}))
    }
    // Warn once per session ONLY on a genuinely high round-trip to our own API.
    // Deliberately NOT triggered by a cold-start retry (a slow first request on
    // a fast pipe is what the retry handles, not a slow link) nor by
    // navigator.connection (unreliable on desktop - false-positives on gigabit
    // ethernet). Threshold set high so a normal cold CloudFront hit won't fire.
    evaluateConnectionQuality(rttMs,attempt,forceSlow){
      if(this.slowToastShown) return
      const slow = forceSlow === true || (typeof rttMs === 'number' && rttMs > 3000)
      if(slow){
        this.slowToastShown = true
        console.log('[conn] slow connection - rtt ' + rttMs + 'ms')
        this.showToast('Slow connection detected - presentations may take longer to load.')
      }
    }
    updatebookmarks(){
      // console.log('update bookmarks')
      let strBooks=localStorage.getItem('bookmarks')
      if(strBooks)this.bookmarks=JSON.parse(strBooks)
    }

    isNarrativeDownloaded(nid) {
      // Is THIS deck's content on disk? Deliberately separate from connectivity.
      //
      // `expo.downloaded` holds OBJECTS ({id, ...}), which is why every
      // `downloaded.indexOf(nid)` in this codebase silently answered -1 forever: it
      // compares an object to a string. The route param is a string and the stored id may
      // be either, so both sides are parsed. Narrative.js already did it this way; this
      // is that comparison in one place so the other call sites can stop getting it wrong.
      const id = parseInt(nid, 10)
      if (!id) return false
      let arr = []
      try {
        const cookie = localStorage.getItem('expo.downloaded')
        if (cookie) arr = JSON.parse(cookie)
      } catch (e) {
        return false
      }
      if (!Array.isArray(arr)) return false
      return arr.findIndex(a => a && parseInt(a.id, 10) === id) !== -1
    }

    // Should content/API paths resolve to local files right now? Content availability
    // ONLY -- never connectivity. Being online is not a reason to stream a deck that is
    // already sitting on the disk.
    shouldUseLocalContent(nid) {
      if (!(this.electron || this.ios)) return false
      return this.isNarrativeDownloaded(nid === undefined ? this.nid : nid)
    }

    checkInternetConnectivity() {
      // Initial check using navigator.onLine
      this.noInternet = !navigator.onLine;
      if (this.noInternet) {
        this.offlineMode = true;
        localStorage.setItem('offlineMode', 'true');
        Globals.instance().useCMS = false;
        Globals.instance().useLocal = true;
        try {
          ControllerServerComs.instance().postMessageFromServerToElectron("offline-mode",'true')
        } catch (error) {
          console.log("Could not send offline mode to electron:", error)
        }
      }
      
      // Listen for online/offline events
      window.addEventListener('online', () => {
        this.noInternet = false;
        this.offlineMode = false;
        // this.offlineMode = false;
        console.log('[conn] browser online event - connection restored');
        this.events.emit('internet-status-changed', true);
        localStorage.setItem('offlineMode', 'false');
       
      });
      
      window.addEventListener('offline', () => {
        this.noInternet = true;
        this.offlineMode = true;
        Globals.instance().useCMS = false;
        Globals.instance().useLocal = true;

        console.log('[conn] browser offline event - connection lost, verifying with ping...');
        this.events.emit('internet-status-changed', false);

        // Verify with a real ping - the offline event can fire spuriously
        // during heavy native downloads on iOS (Alamofire network congestion)
        this.verifyInternetWithPing();
      });
      
      // Additional check with a network request (optional - more reliable)
      return this.verifyInternetWithPing();
    }
    
    verifyInternetWithPing() {
      // Verify reachability of the API we actually depend on (not a third party)
      // and give a slow COLD-START network a fair chance before latching offline.
      //
      // Previously this fired a single 5s HEAD ping at google.com. On a kiosk
      // whose connection is slow to wake, that one request lost the race, the
      // app latched offlineMode=true, fetchNarratives then returned only the
      // downloaded spaces, and thumbnails rewrote to missing local files. It
      // stayed stuck until reload (the periodic re-check was disabled on
      // Electron/iOS). We now retry with escalating timeouts against the real
      // API base, and only conclude offline after every attempt fails.
      const base = this.adminAPI || 'https://www.google.com';

      // Escalating per-attempt timeouts: ~25s worst case before we decide the
      // network is genuinely down. A healthy network resolves on the first
      // attempt in well under a second, so normal startups are unaffected.
      const timeouts = [5000, 8000, 12000];

      const ping = (timeout) => {
        const started = performance.now();
        return fetch(base + '/?_conn=' + this.build + '-' + Math.round(performance.now()), {
          method: 'HEAD',
          mode: 'no-cors',
          cache: 'no-cache',
          signal: AbortSignal.timeout(timeout)
        }).then(() => Math.round(performance.now() - started));
      };

      const markOnline = (attempt, rttMs) => {
        // Fully restore the online state so a recovered kiosk stops resolving
        // content/API paths to local files. localStorage is OR'd into the
        // offline check in AssetManager, so it must be cleared too. Logging is
        // unconditional (so a healthy start is visible in the log); the
        // transition event only fires when we were actually offline, so the
        // self-heal refetch does not run on every 30s recheck.
        const wasOffline = this.noInternet || this.offlineMode;
        this.noInternet = false;
        this.offlineMode = false;
        // NOT an unconditional false (#1916). This runs on a 30s timer, so forcing it
        // false meant a DOWNLOADED deck resolved to local files for at most 30 seconds
        // after opening and then silently reverted to streaming its JSON and its media
        // from CloudFront -- on a client with a slow or filtered network that is the
        // 10-15s page change George reported, and it got worse the better the
        // connectivity check went. Nothing set it back: every other `useLocal = true`
        // is on an offline path, and the one online site runs at deck open.
        //
        // useLocal answers "is this deck's content on disk", which connectivity does not
        // change. Recompute it from the manifest instead of clearing it.
        this.useLocal = this.shouldUseLocalContent();
        this.useCMS = this.usecms;
        this.connectionRttMs = rttMs;
        localStorage.setItem('offlineMode', 'false');
        console.log('[conn] ONLINE - verified on attempt ' + attempt + ' rtt ' + rttMs + 'ms' + (wasOffline ? ' (recovered from offline)' : ''));
        if (wasOffline) this.events.emit('internet-status-changed', true);
        this.evaluateConnectionQuality(rttMs, attempt);
        return true;
      };

      const markOffline = () => {
        const wasOnline = !this.noInternet && !this.offlineMode;
        this.noInternet = true;
        this.offlineMode = true;
        // Route content/API paths to LOCAL files. Without useLocal, getCMSPath
        // (themes, narrative groups) resolves to the unreachable remote API and
        // fetchCMSJSON has no timeout, so an offline boot hangs on the loader.
        // Mirrors markOnline (which restores useLocal=false on recovery).
        this.useLocal = true;
        this.useCMS = false;
        localStorage.setItem('offlineMode', 'true');
        console.log('[conn] OFFLINE - all ' + timeouts.length + ' attempts failed');
        if (wasOnline) this.events.emit('internet-status-changed', false);
        return false;
      };

      const tryFrom = (i) => {
        console.log('[conn] ping attempt ' + (i + 1) + '/' + timeouts.length + ' (' + timeouts[i] + 'ms) -> ' + base);
        return ping(timeouts[i])
          .then((rttMs) => markOnline(i + 1, rttMs))
          .catch(() => {
            if (i + 1 < timeouts.length) {
              console.log('[conn] attempt ' + (i + 1) + ' failed, retrying...');
              return tryFrom(i + 1);
            }
            return markOffline();
          });
      };

      return tryFrom(0);
    }
    
    // Method to manually check internet status (can be called periodically)
    recheckInternetStatus() {
      return this.verifyInternetWithPing();
    }

    toggleFullscreen(){
      if(this.electron){
        window.api.send("toApp", {"event":"toggle-fullscreen"});
        return
      }
      
      if(!document.fullscreenElement){
        document.documentElement.requestFullscreen().then(()=>{this.isFullscreen=true}).catch(err => {
          console.log(err)
        })
      }else if (document.exitFullscreen) {
        document.exitFullscreen();
        this.isFullscreen=false
      }

    }
  }
    

    



  return {
    instance: function(){
      // check if instance is available
      if (!instance) {
        instance = new globals();
        instance.init()
        delete instance.constructor; // or set it to null
      }
      return instance;
    }
  };
})();


export default Globals